import * as React from "react";

const SvgToggleViewPanel = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.571 19.714v-5.143c0-.71.576-1.285 1.286-1.285h12.857c.71 0 1.286.575 1.286 1.285v5.143c0 .71-.576 1.286-1.286 1.286H6.857c-.71 0-1.286-.576-1.286-1.286m9-5.143H6.857v5.143h7.714zM18.43 4.286v5.143c0 .71-.576 1.285-1.286 1.285H4.286C3.576 10.714 3 10.14 3 9.43V4.286C3 3.576 3.576 3 4.286 3h12.857c.71 0 1.286.576 1.286 1.286m-6.429 0H4.286v5.143H12z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgToggleViewPanel;
